import PropTypes from "prop-types";
import React from "react";

import { Button } from "../Button";

import { defaultNPSRatingButtons } from "./constant";
import { NPSSurveyWrapper } from "./NPSSurveyWrapper";

import "./styles.scss";

export const NPSRating = ({ buttons, className, dismissHandler, featureArea, submitHandler }) => {
  return (
    <NPSSurveyWrapper className={className} dismissHandler={dismissHandler}>
      <div className="apti-NPSRating--label">
        How likely is it that you would recommend{" "}
        <span className="font-weight-bold">{featureArea} features in aptihealth</span>
        &nbsp;to a colleague?
      </div>
      <div className="apti-NPSRating--input-group">
        {buttons.map((button) => {
          return (
            <Button
              buttonType={button.buttonType}
              className="apti-NPSRating--input"
              key={button.value}
              onClick={submitHandler}
              style={{ flexBasis: `${1 / buttons.length}%` }}
              value={button.value}
            >
              {button.label}
            </Button>
          );
        })}
      </div>
    </NPSSurveyWrapper>
  );
};

NPSRating.propTypes = {
  buttons: PropTypes.array.isRequired,
  className: PropTypes.string,
  dismissHandler: PropTypes.func.isRequired,
  featureArea: PropTypes.string,
  submitHandler: PropTypes.func.isRequired,
};

NPSRating.defaultProps = {
  buttons: defaultNPSRatingButtons,
  className: undefined,
  dismissHandler: () => {},
  featureArea: "",
  submitHandler: () => {},
};
